<script>
  import { onMount } from "svelte";
  import { token } from "./store/token.js";
  import { section } from "./store/section.js";
  import "./store/router.js"; // activates hash <-> section URL routing
  import { permissions, canAccess, SECTION_PERMISSIONS } from "./store/permissions.js";
  import { apiRequest } from "./api/request.js";
  import { get } from "svelte/store";

  import UserList from "./UserList.svelte";
  import UserListV2 from "./UserListV2.svelte";
  import Navbar from "./Navbar.svelte";
  import Dashboard from "./Dashboard.svelte";
  import Login from "./Login.svelte";
  import Push from "./Push.svelte";
  import Promo from "./Promo.svelte";
  import Workspaces from "./Workspaces.svelte";
  import Upgrades from "./Upgrades.svelte";
  import AdminUsers from "./AdminUsers.svelte";
  import BillingPlansV2 from "./BillingPlansV2.svelte";

  $: is_logged = $token != "";

  onMount(() => {
    if (get(token)) {
      apiRequest(`${process.env.API_ROOT}/admin/me`)
        .then((me) => {
          permissions.update((p) => ({
            ...p,
            role: me.role ?? p.role,
            channels: me.channels ?? p.channels,
            pages: me.pages ?? p.pages,
            email: me.email ?? p.email
          }));
        })
        .catch(() => {
          // 401/403 already cleared token/permissions in handleApiResponse; app shows Login
        });
    }
  });

  // Retired sections that are no longer surfaced in the nav — always redirect
  // away (User List V1 is superseded by V2; Upgrades and Promo are hidden).
  const RETIRED_SECTIONS = ['user_list', 'upgrades', 'promo', 'push'];

  // Route protection: redirect to first allowed section if current is
  // unauthorized OR points at a retired section.
  $: {
    if (is_logged && $section) {
      const permKey = SECTION_PERMISSIONS[$section];
      const isRetired = RETIRED_SECTIONS.includes($section);
      if (isRetired || (permKey && !$canAccess[permKey])) {
        // Find first accessible, still-visible section
        if ($canAccess.workspace_info) {
          section.set('workspaces');
        } else if ($canAccess.user_list) {
          section.set('user_list_v2');
        } else if ($canAccess.analytics) {
          section.set('dashboard');
        } else if ($canAccess.billing_plans) {
          section.set('billing_plans');
        }
      }
    }
  }

  console.log($token, $token == "", typeof $token, $token.toString());

  // ---

  /*
  (function (apiKey) {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? "unshift" : "push"](
                [m].concat([].slice.call(arguments, 0)),
              );
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = "https://cdn.eu.pendo.io/agent/static/" + apiKey + "/pendo.js";
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
  })("b33076a4-4f13-48a5-449f-b2d64d4d2bea");

  pendo.initialize({
    dataHost: "http://localhost:1338",
    sendEventsWithPostOnly: true,
  });
  */

  // ---
</script>

{#if is_logged}
  <div class="app-container">
    <Navbar />
    <main class="main-content">
      {#if $section == "dashboard"}
        <Dashboard />
      {:else if $section == "user_list"}
        <UserList />
      {:else if $section == "user_list_v2"}
        <UserListV2 />
      {:else if $section == "push"}
        <Push />
      {:else if $section == "promo"}
        <Promo />
      {:else if $section == "workspaces"}
        <Workspaces />
      {:else if $section == "upgrades"}
        <Upgrades />
      {:else if $section == "admin_users"}
        <AdminUsers />
      {:else if $section == "billing_plans"}
        <BillingPlansV2 />
      {/if}
    </main>
  </div>
{:else}
  <Login />
{/if}

<style>
  .app-container {
    display: flex;
    min-height: 100vh;
  }

  .main-content {
    flex: 1;
    margin-left: 280px;
    min-height: 100vh;
    background: var(--ds-app-bg, #f5f7fa);
  }

  @media (max-width: 768px) {
    .main-content {
      margin-left: 0;
    }
  }
</style>
